/** Base path do portal revenda (prefixo da rota React). */
export const PARTNER_CONSOLE_BASE = "/partner/console";

export const PARTNER_CONSOLE_SEGMENT = {
  overview: "overview",
  workspaces: "workspaces",
  presence: "presence",
  pricing: "pricing",
  workspaceCreate: "workspaces/new",
};

export const PARTNER_CONSOLE_PATH = {
  overview: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.overview}`,
  workspaces: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.workspaces}`,
  presence: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.presence}`,
  pricing: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.pricing}`,
  workspaceCreate: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.workspaceCreate}`,
};

/** Path absoluto do detalhe de um workspace revenda. */
export function partnerWorkspaceDetailPath(dominioId) {
  const id = String(dominioId || "").trim();
  if (!id) return PARTNER_CONSOLE_PATH.workspaces;
  return `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.workspaces}/${encodeURIComponent(id)}`;
}
